import type { FmTextFieldTrailingSubmitDescriptor } from './FmForm.types';

export function assertTextFieldTrailingSubmitIsSingleLine(
  multiline: boolean | undefined,
  trailingSubmit: FmTextFieldTrailingSubmitDescriptor | undefined,
): void {
  if (multiline && trailingSubmit) {
    throw new Error('FmTextField trailingSubmit is available only for single-line fields');
  }
}
